import api from './Api'

export default {
  // Actualizar un TODO de un vehículo
  updateVehicleTodo(vehicleId, todoId, data) {
    return api().put(`/vehicles/${vehicleId}/update-todo/${todoId}`, data)
  },

  // Cerrar un TODO de un vehículo
  close(vehicleId, todoId) {
    return this.updateVehicleTodo(vehicleId, todoId, { status: 'closed' })
  }
}
